import { makeStyles } from '@material-ui/core';

export default makeStyles({
  commentsWrapper: {
    marginTop: 24,
  },
});
